import PropTypes from "prop-types";
import { useRef } from "react";
import { pushGTMAnalyticsEvent } from "../../../modules/pushGTMAnalyticsEvent";
import "./styles.scss";

export const RectangleButton = ({
  type = "submit",
  label,
  iconSrc,
  onClickHandler = null,
  gaObj,
  iconOnly = false,
  disabled = false,
  ariaLabel,
}) => {
  const skipClickFromTouchRef = useRef(false);

  const handleClick = (e) => {
    if (disabled) return;
    if (onClickHandler) onClickHandler(e);

    pushGTMAnalyticsEvent(gaObj);
  };

  return (
    <button
      type={type}
      disabled={disabled}
      aria-label={ariaLabel || label}
      title={ariaLabel || label}
      onClick={(e) => {
        if (skipClickFromTouchRef.current) {
          skipClickFromTouchRef.current = false;
          return;
        }
        handleClick(e);
      }}
      onTouchStart={(e) => {
        e.preventDefault();
        skipClickFromTouchRef.current = true;
        handleClick(e);
        window.setTimeout(() => {
          skipClickFromTouchRef.current = false;
        }, 400);
      }}
      className={`p-2 m-2 rectangleBtn${iconOnly ? " iconOnly" : ""}${disabled ? " disabled" : ""}`}
    >
      {label}
      {iconSrc && <img alt="" src={iconSrc} />}
    </button>
  );
};

RectangleButton.propTypes = {
  label: PropTypes.string,
  iconSrc: PropTypes.string,
  onClickHandler: PropTypes.func,
  iconOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  ariaLabel: PropTypes.string,
};
